import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as UserDataConfig from '../../config/user-data.config';
import { GetCMSDataService, StartQuoteService } from '../../../../shared';
import { Router } from '@angular/router';
@Component({
  selector: 'app-personal-details_not_require',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss']
})
export class PersonalDetailsComponent implements OnInit {
  public userInputDetail = UserDataConfig.ElementsConfig;
  userForm: UntypedFormGroup;
  userData: any;
  constructor(private fb: UntypedFormBuilder, private startQuoteService: StartQuoteService, private messageService: GetCMSDataService,
    private router: Router) { }

  ngOnInit() {
    this.userFormData();
    // this.startQuoteService.setRefNo('');
    this.messageService.userDetail.subscribe(response => this.userData = response);
  }


  userFormData = () => {
    this.userInputDetail.buttonConfig.label = 'Next';
    this.userForm = this.fb.group({
      next: ['']
    });
  }

  goBack = (userForm: any) => {
    this.messageService.sendUserData({ data: userForm ? userForm.value : null, index: 0 });
    // this.cmsService.sendUserData(userForm.value);
    this.router.navigate(['/home/create']);
  }

  gotoNextPage = () => {
    this.router.navigate(['/home/your-pension-savings']);
  }
}
